import { environment } from 'src/environments/environment';
import {
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { AuthService } from 'src/app/shared/services/authentication/auth.service';
import { AppConfigService } from 'src/app/shared/services/AppConfigService';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { CurrentUserDto } from 'src/app/shared/models/current-user.model';
import { CryptoService } from 'src/app/shared/services/crypto';
import { AjaxInterceptorService } from 'src/app/shared/interceptors/AjaxInterceptorService';
import { CacheService } from 'src/app/shared/services/cashe-service';
import { IdleService } from '../../shared/services/idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent extends BaseComponent {
  @Input() isAdmin: boolean = false;
  @ViewChild('mainContainer') mainContainer: ElementRef;

  constructor(
    private ajaxInterceptorSvc: AjaxInterceptorService,

    public authService: AuthService,
    public override router: Router,
    private cryptoService: CryptoService,
    private idleService: IdleService,
    public configService?: AppConfigService
  ) {
    super();
    this.loadAppConfig();
  }
  scripts = [
    'assets/myUI/js/jquery.js',
    'assets/myUI/app-assets/vendors/js/vendors.min.js',
    'assets/myUI/app-assets/js/core/app-menu.js',
    'assets/myUI/app-assets/js/core/app.js'
  ];

  // Load scripts in order
  loadAllScripts() {
    try {
      this.loadScript2(this.scripts[0])
        .then(() => this.loadScript2(this.scripts[1]))
        .then(() => this.loadScript2(this.scripts[2]))
        .then(() => this.loadScript2(this.scripts[3]))
        .then(() => console.log('All scripts loaded successfully'))
        .catch(error => console.error('Script loading error:', error));



      // this.loadScript('assets/myUI/js/jquery.js');
      // setTimeout(() => {
      //   this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
      // }, 100); // Delay to ensure DOM is ready
      // setTimeout(() => {
      //   this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
      //   // this.loadScript('assets/myUI/app-assets/js/core/app.js');

      // }, 300); // Delay to ensure DOM is ready
      // setTimeout(() => {
      //   //this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
      //   this.loadScript('assets/myUI/app-assets/js/core/app.js');
      // }, 700); // Delay to ensure DOM is ready

      window.onload = () => {
        console.log('✅ All scripts and assets have loaded.');
      };
    } catch (error) {
      console.error('❌ Error loading scripts:', error);
    }


  }
  isDarkTheme: boolean = false;
  ngOnInit(): void {
    this.isDarkTheme = localStorage.getItem('themeMode') === 'dark';


  }

  ngAfterViewInit() {
    // var customScriptFile = document.createElement('script');
    // customScriptFile.type = 'text/javascript';
    // customScriptFile.id = 'script';
    // this.mainContainer.nativeElement.appendChild(customScriptFile);

  }

  ngAfterViewChecked() {
    const readonlyTextAreaList = document.querySelectorAll('textarea');

    readonlyTextAreaList.forEach((textarea: HTMLTextAreaElement) => {
      const scrollHeight = textarea.scrollHeight;
      textarea.style.height = scrollHeight + 'px';
    });

    const tables = document.querySelectorAll('.table');
    tables.forEach(table => {
      var headertext = [],
        tableHeaders = table.querySelectorAll('thead th, thead td'),
        tableBody = table.querySelector('tbody');
      for (var i = 0; i < tableHeaders.length; i++) {
        var current = tableHeaders[i];
        headertext.push(current.textContent.replace(/\r?\n|\r/, ''));
      }
      if (tableBody !== null) {
        for (var i = 0, row; row = tableBody.rows[i]; i++) {
          for (var j = 0, col; col = row.cells[j]; j++) {
            if (headertext[j] != undefined) {
              col.setAttribute('data-th', headertext[j]);
            }
          }
        }
      }
    });

  }



  loadAppConfig() {
    var config = this.configService.getConfig();
    environment.appUrl = config.appUri;
    environment.defaultPageSize = config.defaultPageSize;
    environment.attachmentMaxSize = config.attachmentMaxSize;
    environment.apiUrl = config.apiUrl;
    environment.signalRUrl = config.signalR;
    environment.SDIFUrl = config.SDIFUrl;
    this.ajaxInterceptorSvc.setProgressSMasktatus(false);

  }
}
